<template>
  <div>

     <div class="fix-t" >

    <slot>

    </slot>


     </div>


  </div>
</template>

<script>
  export default {
    name: 'NavBar',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },

  }
</script>

<style>
@import url("./navbar.css");

</style>



// WEBPACK FOOTER //
// src/components/navbar/NavBar.vue